module.exports = __webpack_public_path__ + "fonts/cde63a33478dbf6d95dd4dc9ab67c915.svg";